<script setup lang="ts">
import { useComparatorStore } from "@modules/courtage/stores/comparator.store"
import { storeToRefs } from "pinia"
import { onBeforeMount } from "vue"
import { useI18n } from "vue-i18n"

const { t } = useI18n({
    messages: {
        fr: {
            error: {
                title: "Historique de données insuffisant",
                content:
                    "Impossible de faire tourner sur ce compteur en raison d'un historique de données inférieur à 1 an. Il faut 1 an de données au pas horaire au moins pour pricer un contrat.",
            },
        },
    },
})
const comparatorStore = useComparatorStore()

const {
    graphJson,
    isFetchingSourceChart,
    hasErrorSourceChart,
    errorSourceChart,
    sourceSelected,
} = storeToRefs(comparatorStore)

onBeforeMount(() => {
    if (
        graphJson.value?._id_source === sourceSelected.value &&
        graphJson.value?.json
    ) {
        return
    }

    comparatorStore.fetchSourceChart()
})
</script>

<template>
    <div class="card p-4 flex flex-col gap-4">
        <BaseMessage
            severity="error"
            icon="pi pi-times-circle"
            :closable="false"
            class="w-full"
        >
            <strong>{{ t("error.title") }}</strong>
            <p class="mt-1">
                {{ t("error.content") }}
            </p>
        </BaseMessage>
        <div class="relative">
            <BaseChartSkeleton v-if="isFetchingSourceChart || !graphJson" />
            <PlotlyChart v-else :graph="graphJson.json" />
            <BaseMessage
                v-if="hasErrorSourceChart"
                severity="error"
                icon="pi pi-times-circle"
                :closable="false"
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
                {{ errorSourceChart?.message }}
            </BaseMessage>
        </div>
    </div>
</template>
